import { ReactNode } from "react";

interface AlertProps {
  children: ReactNode;
}

/**
 * Shared error-message component that replaces the duplicated inline
 * `role="alert"` block previously copy-pasted in CreateFamily.tsx and
 * JoinFamily.tsx. Uses the --color-error token instead of a hardcoded hex.
 */
export function Alert({ children }: AlertProps) {
  return (
    <p role="alert" style={{ color: "var(--color-error)", marginBottom: "12px", fontSize: "14px" }}>
      {children}
    </p>
  );
}
